import React, { useState } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import {
    GetCustomerGridGridData
} from "../../../../services/SalesOrderService";
import SalesOrderSearchResult from "./CustomerResult";
import CustomerFilters from "./customerFilters";
const CustomerSearchTab = (props) => {
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const searchData = (formFields) => {
        var resultData = GetCustomerGridGridData(accessToken, getCustomerListUrl, formFields);
        setDataSource(resultData);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <CustomerFilters searchData={searchData} />
                        <SalesOrderSearchResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerSearchTab);